(function () {
  if (window.__nsSizeGuideModalReady) return;
  window.__nsSizeGuideModalReady = true;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    var openBtn = document.getElementById('ns-sg-open');
    var modal = document.getElementById('ns-sg-modal');
    var closeBtn = document.getElementById('ns-sg-close');
    if (!openBtn || !modal) return;

    var previousOverflow = '';
    var previousHtmlOverflow = '';

    function lockScroll() {
      previousOverflow = document.body.style.overflow;
      previousHtmlOverflow = document.documentElement.style.overflow;
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    }

    function unlockScroll() {
      document.body.style.overflow = previousOverflow;
      document.documentElement.style.overflow = previousHtmlOverflow;
    }

    function openModal(evt) {
      if (evt) evt.preventDefault();
      modal.hidden = false;
      modal.classList.add('is-open');
      // next frame for fade-in
      requestAnimationFrame(function () {
        modal.classList.add('is-visible');
      });
      lockScroll();
      if (closeBtn) closeBtn.focus();
    }

    function closeModal() {
      modal.classList.remove('is-visible');
      var onEnd = function () {
        modal.classList.remove('is-open');
        modal.hidden = true;
        modal.removeEventListener('transitionend', onEnd);
      };
      modal.addEventListener('transitionend', onEnd);
      // fallback if transitionend doesn't fire
      setTimeout(onEnd, 300);
      unlockScroll();
    }

    openBtn.addEventListener('click', openModal);

    if (closeBtn) {
      closeBtn.addEventListener('click', function (evt) {
        evt.preventDefault();
        closeModal();
      });
    }

    modal.addEventListener('click', function (evt) {
      if (evt.target === modal) closeModal();
    });

    document.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });
  });
})();
